var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-rounded-button',{attrs:{"size":"x-small","tooltip":_vm.$i18n.t('default.generatePdf'),"icon":"mdi-printer","color":"rgba(235, 235, 235, 0.5)","iconColor":"#202124","loading":_vm.loading},on:{"click":_vm.getPdf}})
}
var staticRenderFns = []

export { render, staticRenderFns }